var map = {
	"./CategoriesSlider": [
		81726,
		89103,
		81726
	],
	"./CategoriesSlider/": [
		81726,
		89103,
		81726
	],
	"./CategoriesSlider/helpers": [
		61042,
		61042
	],
	"./CategoriesSlider/helpers.ts": [
		61042,
		61042
	],
	"./CategoriesSlider/index": [
		81726,
		89103,
		81726
	],
	"./CategoriesSlider/index.tsx": [
		81726,
		89103,
		81726
	],
	"./CategoriesSlider/styled": [
		78183,
		78183
	],
	"./CategoriesSlider/styled.ts": [
		78183,
		78183
	],
	"./LiveSpins": [
		98821,
		98821
	],
	"./LiveSpins/": [
		98821,
		98821
	],
	"./LiveSpins/index": [
		98821,
		98821
	],
	"./LiveSpins/index.tsx": [
		98821,
		98821
	],
	"./LiveSpins/styled": [
		67160,
		67160
	],
	"./LiveSpins/styled.ts": [
		67160,
		67160
	],
	"./LiveSpins/types": [
		13155,
		13155
	],
	"./LiveSpins/types.ts": [
		13155,
		13155
	],
	"./LobbyGamesSlider": [
		25019,
		89103,
		25019
	],
	"./LobbyGamesSlider/": [
		25019,
		89103,
		25019
	],
	"./LobbyGamesSlider/components/Slide/Slide": [
		53193,
		53193
	],
	"./LobbyGamesSlider/components/Slide/Slide.tsx": [
		53193,
		53193
	],
	"./LobbyGamesSlider/components/Slide/styled": [
		7645,
		7645
	],
	"./LobbyGamesSlider/components/Slide/styled.ts": [
		7645,
		7645
	],
	"./LobbyGamesSlider/index": [
		25019,
		89103,
		25019
	],
	"./LobbyGamesSlider/index.tsx": [
		25019,
		89103,
		25019
	],
	"./PaymentsSlider": [
		7032,
		89103,
		7032
	],
	"./PaymentsSlider/": [
		7032,
		89103,
		7032
	],
	"./PaymentsSlider/index": [
		7032,
		89103,
		7032
	],
	"./PaymentsSlider/index.tsx": [
		7032,
		89103,
		7032
	],
	"./PaymentsSlider/styled": [
		13263,
		13263
	],
	"./PaymentsSlider/styled.ts": [
		13263,
		13263
	],
	"./PromotionsCarousel": [
		68750,
		89103,
		51875
	],
	"./PromotionsCarousel/": [
		68750,
		89103,
		51875
	],
	"./PromotionsCarousel/PromotionCard": [
		96271,
		96271
	],
	"./PromotionsCarousel/PromotionCard/": [
		96271,
		96271
	],
	"./PromotionsCarousel/PromotionCard/index": [
		96271,
		96271
	],
	"./PromotionsCarousel/PromotionCard/index.tsx": [
		96271,
		96271
	],
	"./PromotionsCarousel/PromotionCard/styled": [
		43911,
		43911
	],
	"./PromotionsCarousel/PromotionCard/styled.ts": [
		43911,
		43911
	],
	"./PromotionsCarousel/index": [
		68750,
		89103,
		51875
	],
	"./PromotionsCarousel/index.tsx": [
		68750,
		89103,
		51875
	],
	"./PromotionsSlider": [
		31459,
		89103,
		31459
	],
	"./PromotionsSlider/": [
		31459,
		89103,
		31459
	],
	"./PromotionsSlider/Promotion": [
		2626,
		2626
	],
	"./PromotionsSlider/Promotion/": [
		2626,
		2626
	],
	"./PromotionsSlider/Promotion/helpers": [
		63755,
		63755
	],
	"./PromotionsSlider/Promotion/helpers.ts": [
		63755,
		63755
	],
	"./PromotionsSlider/Promotion/index": [
		2626,
		2626
	],
	"./PromotionsSlider/Promotion/index.tsx": [
		2626,
		2626
	],
	"./PromotionsSlider/Promotion/styled": [
		14310,
		14310
	],
	"./PromotionsSlider/Promotion/styled.ts": [
		14310,
		14310
	],
	"./PromotionsSlider/index": [
		31459,
		89103,
		31459
	],
	"./PromotionsSlider/index.tsx": [
		31459,
		89103,
		31459
	],
	"./PromotionsSlider/styled": [
		41364,
		41364
	],
	"./PromotionsSlider/styled.ts": [
		41364,
		41364
	],
	"./ProvidersSlider": [
		14442,
		89103,
		14442
	],
	"./ProvidersSlider/": [
		14442,
		89103,
		14442
	],
	"./ProvidersSlider/ProviderCard": [
		71120,
		71120
	],
	"./ProvidersSlider/ProviderCard.tsx": [
		71120,
		71120
	],
	"./ProvidersSlider/helpers": [
		66113,
		66113
	],
	"./ProvidersSlider/helpers.ts": [
		66113,
		66113
	],
	"./ProvidersSlider/index": [
		14442,
		89103,
		14442
	],
	"./ProvidersSlider/index.tsx": [
		14442,
		89103,
		14442
	],
	"./ProvidersSlider/styled": [
		41218,
		41218
	],
	"./ProvidersSlider/styled.ts": [
		41218,
		41218
	],
	"./RegistrationSlider": [
		96581,
		74332,
		39342,
		25442,
		89103,
		96581
	],
	"./RegistrationSlider/": [
		96581,
		74332,
		39342,
		25442,
		89103,
		96581
	],
	"./RegistrationSlider/components/RegBanner": [
		34785,
		34785
	],
	"./RegistrationSlider/components/RegBanner/": [
		34785,
		34785
	],
	"./RegistrationSlider/components/RegBanner/index": [
		34785,
		34785
	],
	"./RegistrationSlider/components/RegBanner/index.tsx": [
		34785,
		34785
	],
	"./RegistrationSlider/components/RegBanner/styled": [
		75176,
		81184
	],
	"./RegistrationSlider/components/RegBanner/styled.ts": [
		75176,
		81184
	],
	"./RegistrationSlider/helpers": [
		12897,
		12897
	],
	"./RegistrationSlider/helpers.ts": [
		12897,
		12897
	],
	"./RegistrationSlider/index": [
		96581,
		74332,
		39342,
		25442,
		89103,
		96581
	],
	"./RegistrationSlider/index.tsx": [
		96581,
		74332,
		39342,
		25442,
		89103,
		96581
	],
	"./RegistrationSlider/styled": [
		19926,
		19926
	],
	"./RegistrationSlider/styled.ts": [
		19926,
		19926
	],
	"./StarWinners": [
		25634,
		25634
	],
	"./StarWinners/": [
		25634,
		25634
	],
	"./StarWinners/NewWinner": [
		25966,
		25966
	],
	"./StarWinners/NewWinner/": [
		25966,
		25966
	],
	"./StarWinners/NewWinner/index": [
		25966,
		25966
	],
	"./StarWinners/NewWinner/index.tsx": [
		25966,
		25966
	],
	"./StarWinners/NewWinner/styled": [
		98899,
		2349
	],
	"./StarWinners/NewWinner/styled.ts": [
		98899,
		2349
	],
	"./StarWinners/PrimeWinner": [
		84945,
		84945
	],
	"./StarWinners/PrimeWinner/": [
		84945,
		84945
	],
	"./StarWinners/PrimeWinner/index": [
		84945,
		84945
	],
	"./StarWinners/PrimeWinner/index.tsx": [
		84945,
		84945
	],
	"./StarWinners/PrimeWinner/styled": [
		1772,
		1772
	],
	"./StarWinners/PrimeWinner/styled.ts": [
		1772,
		1772
	],
	"./StarWinners/components/Winners": [
		6788,
		6788
	],
	"./StarWinners/components/Winners/": [
		6788,
		6788
	],
	"./StarWinners/components/Winners/index": [
		6788,
		6788
	],
	"./StarWinners/components/Winners/index.tsx": [
		6788,
		6788
	],
	"./StarWinners/data": [
		5466,
		5466
	],
	"./StarWinners/data.ts": [
		5466,
		5466
	],
	"./StarWinners/index": [
		25634,
		25634
	],
	"./StarWinners/index.tsx": [
		25634,
		25634
	],
	"./StarWinners/styled": [
		6463,
		6463
	],
	"./StarWinners/styled.ts": [
		6463,
		6463
	],
	"./TopicsSlider": [
		98348,
		89103,
		98348
	],
	"./TopicsSlider/": [
		98348,
		89103,
		98348
	],
	"./TopicsSlider/index": [
		98348,
		89103,
		98348
	],
	"./TopicsSlider/index.tsx": [
		98348,
		89103,
		98348
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73639;
module.exports = webpackAsyncContext;